import React__default from 'react';
import PropTypes from 'prop-types';
import { I as Icon } from './index-11bc5ac3.js';
import Title from './Title.js';
import { n as nodeOrStringProp } from './PropTypes-e1e509ba.js';

function ModalCloseIcon(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-modal-close",
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: "bf-icon-times"
  }));
}
ModalCloseIcon.propTypes = {
  onClick: PropTypes.func.isRequired
};

function ModalHeader(_ref) {
  var title = _ref.title,
    closeIcon = _ref.closeIcon,
    onClose = _ref.onClose;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-modal-header ".concat(title ? 'bf-modal-has-title' : '')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-modal-title"
  }, /*#__PURE__*/React__default.createElement(Title, {
    content: title,
    size: "large"
  })), closeIcon ? /*#__PURE__*/React__default.createElement(ModalCloseIcon, {
    onClick: onClose
  }) : null);
}
ModalHeader.defaultProps = {
  title: '',
  closeIcon: false
};
ModalHeader.propTypes = {
  closeIcon: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  title: nodeOrStringProp
};

export { ModalHeader as M };
//# sourceMappingURL=ModalHeader-77a50105.js.map
